import VersionContainer from './containers/VersionContainer'

// Sync route definition
export default {
  path      : '/versions',
  component : VersionContainer
}



// WEBPACK FOOTER //
// ./src/routes/Versions/index.js